import { z } from "zod";
export const accessRecertificationTargetKindSchema = z.literal("data-role");
export const accessRecertificationDecisionSchema = z.enum(["pending", "certified", "revoked"]);
export const createAccessRecertificationCampaignInputSchema = z.object({
    name: z.string().trim().min(1).max(160),
    reviewerPrincipalId: z.string().trim().min(1).max(200).optional(),
}).strict();
export const decideAccessRecertificationItemInputSchema = z.object({
    decision: z.enum(["certify", "revoke"]),
    reason: z.string().trim().min(1).max(1000),
}).strict();
export const cancelAccessRecertificationCampaignInputSchema = z.object({
    reason: z.string().trim().min(1).max(1000),
}).strict();
export const accessRecertificationEvidenceSchema = z.object({
    windowDays: z.literal(90),
    lastUsedAt: z.number().int().nonnegative().nullable(),
    sampleCount: z.number().int().nonnegative(),
    coverage: z.enum(["sampled-attributed", "unavailable"]),
    confidence: z.enum(["directional", "none"]),
    attribution: z.literal("data-role-entity"),
}).strict();
export const accessRecertificationItemSchema = z.object({
    id: z.string().min(1),
    targetKind: accessRecertificationTargetKindSchema,
    targetId: z.string().min(1),
    targetSnapshot: z.record(z.string(), z.unknown()),
    evidence: accessRecertificationEvidenceSchema,
    decision: accessRecertificationDecisionSchema,
    decidedBy: z.string().nullable(),
    decisionReason: z.string().nullable(),
    decidedAt: z.number().nullable(),
    revocationVerifiedAt: z.number().nullable(),
}).strict();
export const accessRecertificationCampaignSchema = z.object({
    id: z.string().min(1),
    organisationId: z.string().min(1),
    name: z.string().min(1),
    reviewerPrincipalId: z.string().min(1),
    status: z.enum(["open", "completed", "cancelled"]),
    snapshotHash: z.string().regex(/^[a-f0-9]{64}$/u),
    artifactHash: z.string().regex(/^[a-f0-9]{64}$/u).nullable(),
    createdBy: z.string().min(1),
    createdAt: z.number(),
    completedAt: z.number().nullable(),
    counts: z.object({ pending: z.number().int().nonnegative(), certified: z.number().int().nonnegative(),
        revoked: z.number().int().nonnegative() }).strict(),
}).strict();
export const accessRecertificationCampaignResponseSchema = z.object({
    campaign: accessRecertificationCampaignSchema,
    items: z.array(accessRecertificationItemSchema),
}).strict();
export const listAccessRecertificationCampaignsResponseSchema = z.object({
    campaigns: z.array(accessRecertificationCampaignSchema),
}).strict();
